import { useEffect } from "react";
import { withRouter } from "react-router-dom";

function ScrollToTop({ location }) {
	const { hash } = location;

	useEffect(() => {
		if (hash === "") {
			window.scrollTo(0, 0);
		} else {
			setTimeout(() => {
				const id = hash.replace("#", "");
				const element = document.getElementById(id);

				if (element) {
					element.scrollIntoView();
				}
			}, 100);
		}
	}, [hash, location]);

	return null;
}

export default withRouter(ScrollToTop);
